"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../../../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        icon: {
            color: palette.grey[400],
            cursor: 'grab',
            marginBottom: 'auto',
            marginTop: spacing(1.2),
            '&:hover': {
                color: palette.grey[700]
            }
        }
    });
});
exports.default = useStyles;
